import React from 'react';
import { useTranslation } from 'react-i18next';

function formatCooldown(ms) {
  const total = Math.ceil(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  if (m > 0) return `${m} min ${s.toString().padStart(2, '0')}`;
  return `${s} s`;
}

export default function RegenerateButton({ onClick, regenerating, cooldownRemainingMs = 0 }) {
  const { t } = useTranslation('tabs');
  const onCooldown = cooldownRemainingMs > 0 && !regenerating;
  const disabled = regenerating || onCooldown;

  let label;
  if (regenerating) label = t('insights.loading');
  else if (onCooldown) label = t('insights.cooldown_remaining', { time: formatCooldown(cooldownRemainingMs) });
  else label = `↻ ${t('insights.btn_refresh')}`;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={{ ...styles.btn, ...(disabled ? styles.btnDisabled : null) }}
      aria-label={regenerating ? t('insights.loading_short') : t('insights.btn_regenerate_aria')}
    >
      {regenerating && <span style={styles.spinner} aria-hidden />}
      <span>{label}</span>
      <style>{`
        @keyframes revyoSpinSm { from { transform: rotate(0); } to { transform: rotate(360deg); } }
      `}</style>
    </button>
  );
}

const styles = {
  btn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    background: 'transparent',
    border: '1px solid #E5E5E0',
    borderRadius: 999,
    padding: '6px 12px',
    fontSize: 12,
    fontWeight: 600,
    color: '#6B6B6B',
    cursor: 'pointer',
    fontFamily: 'inherit',
    whiteSpace: 'nowrap',
  },
  btnDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  spinner: {
    width: 12,
    height: 12,
    border: '2px solid #E8502A',
    borderTopColor: 'transparent',
    borderRadius: '50%',
    animation: 'revyoSpinSm 0.8s linear infinite',
    display: 'inline-block',
  },
};
